import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatTL } from "@/lib/api";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { ShoppingBag, DollarSign, Clock, CheckCircle, XCircle, Users, Layers, Wifi } from "lucide-react";

const Card = ({ title, value, Icon, accent }) => (
  <div className="card-surface card-hover p-5" data-testid={`stat-card`}>
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-400">{title}</span>
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${accent}`}><Icon size={18} /></div>
    </div>
    <div className="text-2xl font-extrabold text-white mt-3">{value}</div>
  </div>
);

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-gray-400">Yükleniyor...</div>;

  return (
    <div>
      <h1 className="text-2xl font-extrabold text-white mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card title="Toplam Sipariş" value={d.total_orders} Icon={ShoppingBag} accent="bg-blue-500/15 text-blue-400" />
        <Card title="Bugünkü Sipariş" value={d.today_orders} Icon={ShoppingBag} accent="bg-indigo-500/15 text-indigo-400" />
        <Card title="Toplam Ciro" value={formatTL(d.total_revenue)} Icon={DollarSign} accent="bg-green-500/15 text-green-400" />
        <Card title="Bugünkü Ciro" value={formatTL(d.today_revenue)} Icon={DollarSign} accent="bg-emerald-500/15 text-emerald-400" />
        <Card title="Bekleyen" value={d.pending_orders} Icon={Clock} accent="bg-yellow-500/15 text-yellow-400" />
        <Card title="Tamamlanan" value={d.completed_orders} Icon={CheckCircle} accent="bg-green-500/15 text-green-400" />
        <Card title="İptal/Hata" value={d.cancelled_orders} Icon={XCircle} accent="bg-red-500/15 text-red-400" />
        <Card title="Müşteri" value={d.total_customers} Icon={Users} accent="bg-purple-500/15 text-purple-400" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
        <div className="card-surface p-5"><div className="flex items-center gap-2 text-sm text-gray-400"><Layers size={16} /> Aktif Servis</div><div className="text-3xl font-extrabold text-white mt-2">{d.active_services}</div></div>
        <div className="card-surface p-5">
          <div className="flex items-center gap-2 text-sm text-gray-400"><Wifi size={16} /> JungleSMM API</div>
          <div className={`text-lg font-bold mt-2 ${d.jungle_ok ? "text-green-400" : "text-red-400"}`}>{d.jungle_ok ? "Bağlı" : "Bağlantı Yok"}</div>
          {d.jungle_balance && <div className="text-xs text-gray-500 mt-1">Bakiye: {d.jungle_balance}</div>}
        </div>
        <div className="card-surface p-5"><div className="flex items-center gap-2 text-sm text-gray-400"><DollarSign size={16} /> Shopier</div><div className={`text-lg font-bold mt-2 ${d.shopier_ok ? "text-green-400" : "text-red-400"}`}>{d.shopier_ok ? "Yapılandırıldı" : "Ayarlanmadı"}</div></div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <div className="card-surface p-5">
          <h3 className="font-bold text-white mb-4">Günlük Ciro (14 gün)</h3>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={d.series}>
              <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" />
              <XAxis dataKey="date" stroke="#6b7280" fontSize={11} />
              <YAxis stroke="#6b7280" fontSize={11} />
              <Tooltip contentStyle={{ background: "#272b38", border: "1px solid #ffffff20", borderRadius: 12, color: "#fff" }} />
              <Line type="monotone" dataKey="revenue" stroke="#d8b4fe" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="card-surface p-5">
          <h3 className="font-bold text-white mb-4">Günlük Sipariş Sayısı</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.series}>
              <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" />
              <XAxis dataKey="date" stroke="#6b7280" fontSize={11} />
              <YAxis stroke="#6b7280" fontSize={11} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "#272b38", border: "1px solid #ffffff20", borderRadius: 12, color: "#fff" }} />
              <Bar dataKey="orders" fill="#ffffff" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
